<template>
  <div class="form-group">
    <input type="number" v-model.lazy="featureProduct.feature_value" class="form-control "/>
  </div>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "FeatureInputNumber",
  props: {
    featureProduct: {},
    product: {},
  }
})
</script>



<style scoped>

</style>